import "../styles/automapLogo.css";

export const AUTOMAPA_LOGO_LOCKUP_SRC = "/client-views/automap/automapa-logo-lockup.png";
export const AUTOMAPA_LOGO_LOCKUP_WIDTH = 1024;
export const AUTOMAPA_LOGO_LOCKUP_HEIGHT = 271;

/**
 * AutoMapa brand lockup — official horizontal logo image.
 */
export default function AutoMapaLogo({
  className = "",
  variant = "on-dark",
}) {
  return (
    <span className={`automap-logo automap-logo--image automap-logo--${variant} ${className}`.trim()}>
      <img
        src={AUTOMAPA_LOGO_LOCKUP_SRC}
        alt=""
        className="automap-logo__image"
        width={AUTOMAPA_LOGO_LOCKUP_WIDTH}
        height={AUTOMAPA_LOGO_LOCKUP_HEIGHT}
        decoding="async"
      />
    </span>
  );
}
